import React from 'react'
import { MdOutlineDelete } from 'react-icons/md'
import { CiEdit } from 'react-icons/ci'
import { Link } from 'react-router-dom'

const RolePermissionsTable = ({ data, onDelete, userPermissions }) => {
  return (
    <div className='overflow-x-auto'>
      <table className='min-w-full table-auto border-collapse'>
        <thead>
          <tr className='bg-prime'>
            <th className='px-6 py-4 text-left  font-medium text-white'>
              Role Name
            </th>
            <th className='px-6 py-4 text-left  font-medium text-white'>
              Permissions
            </th>
            <th className='px-6 py-4 text-center  font-medium text-white'>
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row) => (
              <tr key={row._id} className='border-b'>
                <td className='px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900'>
                  {row.name}
                </td>
                <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
                  <ul className='flex flex-wrap gap-2'>
                    {row.permissions.map((permission, index) => (
                      <li
                        key={index}
                        className='px-2 py-1 bg-gray-200 rounded-md'
                      >
                        {permission}
                      </li>
                    ))}
                  </ul>
                </td>
                {row.name === 'Super Admin' ? null : (
                  <td className='px-6 py-4 flex justify-center items-center whitespace-nowrap text-sm font-medium text-gray-500 space-x-4'>
                    {userPermissions.includes('role:update') ? (
                      <Link
                        to={`/role/${row._id}`}
                        className='inline-block rounded-full p-1 border-2 border-transparent hover:bg-prime text-prime hover:text-white '
                      >
                        <CiEdit className='text-2xl !no-underline' />
                      </Link>
                    ) : null}

                    {userPermissions.includes('role:delete') ? (
                      <button
                        onClick={() => onDelete(row._id)}
                        className='inline-block rounded-full p-1 border-2 border-transparent hover:bg-red-700 text-red-700 hover:text-white '
                      >
                        <MdOutlineDelete className='text-2xl' />
                      </button>
                    ) : null}
                    {!userPermissions.includes('role:update') &&
                      !userPermissions.includes('role:delete') && (
                        <p className='text-dark text-center'>No Access </p>
                      )}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan='3' className='px-6 py-4 text-center text-gray-500'>
                No roles available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default RolePermissionsTable
